// extracted by mini-css-extract-plugin
var _1 = "gDxNc__entry";
var _2 = "gDxNc__entry__icon";
var _3 = "gDxNc__smallFeatures";
export { _1 as "entry", _2 as "entry__icon", _3 as "smallFeatures" }
